module.exports = __webpack_public_path__ + "static/img/materials1.c101479.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materials1.jpg
// module id = Q1Cm
// module chunks = 1